module.exports = __webpack_public_path__ + "static/media/search-result.dcaaf186.PNG";